import React from 'react';
import { TherapistOption } from '../types/booking';
import { XIcon, StarIcon, AwardIcon, ClockIcon } from 'lucide-react';
interface TherapistModalProps {
  therapist: TherapistOption;
  onClose: () => void;
  onBook: () => void;
}
export function TherapistModal({
  therapist,
  onClose,
  onBook
}: TherapistModalProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-62">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-63">
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-64">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-65">Therapist Profile</h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-66">
            <XIcon className="w-5 h-5 text-gray-500" data-id="element-67" />
          </button>
        </div>
        <div className="p-6" data-id="element-68">
          <div className="flex items-start gap-6 mb-6" data-id="element-69">
            <img src={therapist.imageUrl} alt={therapist.name} className="w-32 h-32 rounded-full object-cover" data-id="element-70" />
            <div className="flex-1" data-id="element-71">
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-72">
                {therapist.name}
              </h3>
              <div className="flex items-center gap-2 mt-2" data-id="element-73">
                <div className="flex items-center gap-1" data-id="element-74">
                  <StarIcon className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-75" />
                  <span className="text-lg font-semibold text-gray-900" data-id="element-76">
                    {therapist.rating}
                  </span>
                </div>
                <span className="text-gray-500" data-id="element-77">
                  ({therapist.reviewCount} reviews)
                </span>
              </div>
              <div className="flex items-center gap-2 mt-3 bg-purple-100 px-4 py-2 rounded-full inline-flex" data-id="element-78">
                <ClockIcon className="w-5 h-5 text-purple-600" data-id="element-79" />
                <span className="font-medium text-purple-600" data-id="element-80">
                  Available at {therapist.time}
                </span>
              </div>
            </div>
          </div>
          <div className="mb-6" data-id="element-81">
            <h4 className="font-semibold text-gray-900 mb-2" data-id="element-82">About</h4>
            <p className="text-gray-700 leading-relaxed" data-id="element-83">{therapist.bio}</p>
          </div>
          <div className="mb-6" data-id="element-84">
            <h4 className="font-semibold text-gray-900 mb-3" data-id="element-85">Specialties</h4>
            <div className="flex flex-wrap gap-2" data-id="element-86">
              {therapist.specialties.map((specialty, index) => <span key={index} className="bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium flex items-center gap-2" data-id="element-87">
                  <AwardIcon className="w-4 h-4" data-id="element-88" />
                  {specialty}
                </span>)}
            </div>
          </div>
          <div className="mb-6" data-id="element-89">
            <h4 className="font-semibold text-gray-900 mb-4" data-id="element-90">
              Recent Reviews ({therapist.reviews.length})
            </h4>
            <div className="space-y-4" data-id="element-91">
              {therapist.reviews.map((review, index) => <div key={index} className="bg-gray-50 rounded-lg p-4" data-id="element-92">
                  <div className="flex items-center justify-between mb-2" data-id="element-93">
                    <span className="font-medium text-gray-900" data-id="element-94">
                      {review.customerName}
                    </span>
                    <div className="flex items-center gap-1" data-id="element-95">
                      {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} data-id="element-96" />)}
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm mb-2" data-id="element-97">{review.comment}</p>
                  <span className="text-xs text-gray-500" data-id="element-98">{review.date}</span>
                </div>)}
            </div>
          </div>
          <button onClick={onBook} className="w-full py-3 bg-purple-600 text-white rounded-full font-medium hover:bg-purple-700 transition-colors" data-id="element-99">
            Book {therapist.name} at {therapist.time}
          </button>
        </div>
      </div>
    </div>;
}